import admin from './admin'
import vehicle from "./vehicle";
import driverGuide from './driver-guide'
import guest from './guest';
import vendor from './vendor';
import destination from "./destination";
import route from "./route";
import accommodation from './accommodation';
import transportation from './transportation';
import activity from './activity';
import program from './program';
import packages from './package';
import spj from './spj';
import offerDoc from './offer-document';
// import test from './test'
// import maintenance from './maintenance';
import profil from "./profil";
import paymentMethod from "./payment-method";
import vehicleMaintenance from "./vehicle-maintenance";
import currency from "./currency";
import reports from "./report";
import offerAgent from './offer-document-agent';
import agent from './agent';
import vpt from './vpt';
import vht from './vht';
import backup from './backup';

const routes = [
    {
        path: "/login",
        name: "login",
        component: () => import("@/views/auth/LoginIndex.vue"),
    },
    {
        path: "/",
        component: () => import("@/layouts/MainLayout.vue"),
        children: [
            {
                path: "",
                name: "home",
                component: () => import("@/views/HomeView.vue"),
                meta: {
                    requiresAuth: true,
                    roles: ["Super Admin", "Admin Office", "Manager Driver"],
                },
            },
            ...destination,
            ...route,
            ...profil,
            ...vehicle,
            ...driverGuide,
            ...admin,
            ...guest,
            ...vendor,
            // ...test,
            ...transportation,
            ...activity,
            ...accommodation,
            ...program,
            ...packages,
            ...spj,
            ...offerDoc,
            ...paymentMethod,
            ...vehicleMaintenance,
            ...currency,
            ...reports,
            ...offerAgent,
            ...agent,
            ...vpt,
            ...vht,
            ...backup
        ],
    },

    //handle 404
    {
        path: "/:pathMatch(.*)*",
        name: "not-found",
        component: () => import("@/views/NotFound.vue"),
    },
];

export default routes;
